import { getPublicRuntimeConfig } from '~/cynqueModules/nuxtAccessors'

export function isUsingMockApi(): boolean {
  const fn = `[cynqueModules/isUsingMockApi.ts] isUsingMockApi |`
  const isUsingMock = getPublicRuntimeConfig().mockApi
  console.debug(`${fn} returning ${isUsingMock}`)
  return isUsingMock
}
